<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title">Suche nach Name, Beschreibung oder Id</h4>
    </div>
    <div class="card-content">
      <form>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Tippspiel Id"
                      placeholder="Id"
                      v-model="betgame.id" readonly="readonly">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Tippspiel Name"
                      placeholder="Name"
                      v-model="betgame.name" readonly="readonly">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Icon"
                      placeholder="Icon"
                      v-model="betgame.icon" readonly="readonly">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Created At"
                      placeholder="Created At"
                      v-model="betgame.created_at" readonly="readonly">
            </fg-input>
          </div>
        </div>

        <div class="row">

          <div class="col-md-6">
            <fg-input type="text"
                      :label="invitationLink"
                      placeholder=""
                      v-model="betgame.invitation_code" readonly="readonly">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input type="email"
                      label="Admin Email"
                      placeholder="Email"
                      v-model="betgame.email" readonly="readonly">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Admin Id"
                      placeholder=""
                      v-model="betgame.fk_user" readonly="readonly">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Type (1 = Wettbewerb, 2 = Battle, 3 = Team)"
                      placeholder="Type"
                      v-model="betgame.type" readonly="readonly">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Bet Mode (1 = Ergebnis, 2 = Toto)"
                      placeholder="Bet Mode"
                      v-model="betgame.bet_mode" readonly="readonly">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Sort Mode (1 = 1. Gesamtpunkte, 2. Spieltagssiege, 3. Exakte Tipps, 4. Tordifferenz, 2 = 1. Gesamtpunkte, 2. Exakte Tipps, 3. Spieltagssiege, 4. Tordifferenz)"
                      placeholder="Sort Mode"
                      v-model="betgame.sort_mode" readonly="readonly">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Result Mode (1 = Nach Elferschießen, 2 = Nach Verlängerung, 3 = Nach 90 Minuten)"
                      placeholder="Result Mode"
                      v-model="betgame.result_mode" readonly="readonly">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Wettbewerb"
                      placeholder=""
                      v-model="betgame.competition" readonly="readonly">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Anzahl Spiele"
                      placeholder="0"
                      v-model="betgame.matches" readonly="readonly">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Teams"
                      placeholder="0"
                      v-model="betgame.teams" readonly="readonly">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Aktive Teilnehmer"
                      placeholder="0"
                      v-model="betgame.active_users" readonly="readonly">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Anzahl Tipps"
                      placeholder="0"
                      v-model="betgame.bets" readonly="readonly">
            </fg-input>
          </div>
        </div>

        <div class="row">
            <div class="col-md-6">
              <fg-input type="text"
                        label="Anzahl Sonderfragen"
                        placeholder="0"
                        v-model="betgame.questions" readonly="readonly">
              </fg-input>
            </div>
            <div class="col-md-6">
              <fg-input type="text"
                        label="Anzahl Antworten"
                        placeholder="0"
                        v-model="betgame.answers" readonly="readonly">
              </fg-input>
            </div>
        </div>

      </form>

      <div class="row" style="margin-top: 20px;">
        <div class="col-sm-12">
          <label>Teilnehmer</label>
          <el-table class="table-striped"
                    :data="queriedUsers"
                    border
                    style="width: 100%">
            <el-table-column v-for="column in userColumns"
                             :key="column.label"
                             :align='column.align'
                             :class-name='column.class'
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label">
            </el-table-column>
          </el-table>
        </div>
      </div>


    </div>
  </div>
</template>
<script>
  import betgame from "./Betgame.vue";

  export default {
    props: {
      id: {
        type: Number,
        default: () => {
          return 0
        }
      }
    },
    computed: {
      invitationLink() {
        return 'Einladungslink https://teamtip.net/join/' + this.betgame.id + '/' + this.betgame.invitation_code
      },
      queriedUsers () {
        return this.betgame.users
      },
      title () {
        if (this.id === 0) {
          return 'Hinzufügen'
        }
        return 'Bearbeiten'
      },
      betgame () {
        if (this.id === 0) {
          return this.new_user
        }
        const user = this.$store.getters.getBetgameById(this.id)
        if (user.length > 0) {
          return user[0]
        }
        return {}
      }
    },
    data () {
      return {
        userColumns: [
          {
            prop: 'id',
            label: 'Id',
            minWidth: 40,
            align: 'left',
            class: 'id-column'
          },
          {
            prop: 'nickname',
            label: 'Teilnehmer',
            minWidth: 130
          },
          {
            prop: 'email',
            label: 'Email',
            minWidth: 130
          }
        ],
      }
    },
    created () {
    },
    methods: {
      isNullOrUndefined (data) {
        return data === null || data === undefined
      },
      isValidEmail (email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(String(email).toLowerCase())
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/BGBackendEditBetgameForm.vue